import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=9b4a9ac0&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=ts&"
export * from "./guide.vue?vue&type=script&lang=ts&"
import style0 from "@/styles/deduction.less?vue&type=style&index=0&lang=less&"
import style1 from "./guide.vue?vue&type=style&index=1&id=9b4a9ac0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4a9ac0",
  null
  
)

export default component.exports